import React from 'react';
import { UploadListItem } from './upload-list-item';
import { pcCssPrefix } from '../constant/css-prefix';
export var UploadList = function (props) {
    var disabled = props.disabled, value = props.value, onChange = props.onChange;
    if (!value.length)
        return null;
    return (React.createElement("div", { className: "".concat(pcCssPrefix, "-list") }, value.map(function (item, index) { return (React.createElement(UploadListItem, { key: item.dingTalkUrl, index: index, disabled: disabled, value: value, onChange: onChange, file: item })); })));
};
